import React from 'react'
import PropTypes from 'prop-types'
import {injectIntl} from 'react-intl'
import { Button, Loader } from '@elparking/components'

import messages from './messages'
import styled from 'styled-components'

const gray = props => props.theme.colors.gray || 'gray'
const warning = props => props.theme.colors.warning || 'warning'

const ButtonContainer = styled.div`
    position: absolute;
    left: 50%;
    top: 20px;
    z-index: 1000000;
    text-align: center;
    width: 320px;
    margin-left: -145px;
`

const Warning = styled.div`
    background: white;
    border-radius: 5px;
    font-size: 13px;
    padding: 10px;
    font-weight: 500;
    color: ${gray};
    max-width: 270px;
    margin: 0 auto;

    & > i {
        margin-right: 10px;
        font-size: 20px;
        color: ${warning};
    }
`

class ReloadButton extends React.PureComponent {
    static propTypes = {
        onClick: PropTypes.func,
        canSearch: PropTypes.bool,
        loading: PropTypes.bool,
        intl: PropTypes.object,
    }

    static defaultProps = {
        canSearch: true,
    }

    render () {
        const {loading, canSearch, intl, onClick} = this.props

        if (loading) {
            return (
                <ButtonContainer>
                    <Button.bordered height='35px' borderRadius='22px' withShadow>
                        <Loader color='mainColor' size='15px' />
                    </Button.bordered>
                </ButtonContainer>
            )
        }

        if (!canSearch) {
            return (
                <ButtonContainer>
                    <Warning>
                        <i className='icon-warning' /> {intl.formatMessage(messages.cantSearchHere)}
                    </Warning>
                </ButtonContainer>
            )
        }

        return (
            <ButtonContainer>
                <Button.bordered height='35px' borderRadius='18px' withShadow fontWeight='book' fontSize='small' onClick={onClick}>
                    {intl.formatMessage(messages.searchHere)}
                </Button.bordered>
            </ButtonContainer>
        )
    }
}

export default injectIntl(ReloadButton)
